// WAI-ARIA menu klavye kararı (saf — DOM ortamı yok, vitest'te sınanır): ↑/↓ etkin öğeler arasında
// döner, Home/End uçlara gider, Esc kapatır ve odağı tetikleyiciye döndürür, Tab kapatır (odak doğal
// akışla ilerler, tetikleyiciye dönmez). Pasif öğeler atlanır.

export type MenuKeyAction =
  | { kind: "focus"; index: number }
  | { kind: "close"; restoreFocus: boolean }
  | null;

/**
 * @param key KeyboardEvent.key
 * @param current odaktaki öğenin indeksi (menü kabında/öğe dışındaysa −1)
 * @param enabled öğe başına etkin mi
 */
export function menuKeyAction(
  key: string,
  current: number,
  enabled: readonly boolean[],
): MenuKeyAction {
  const idx = enabled.map((on, i) => (on ? i : -1)).filter((i) => i >= 0);
  switch (key) {
    case "Escape":
      return { kind: "close", restoreFocus: true };
    case "Tab":
      return { kind: "close", restoreFocus: false };
    case "Home":
      return idx.length > 0 ? { kind: "focus", index: idx[0]! } : null;
    case "End":
      return idx.length > 0 ? { kind: "focus", index: idx[idx.length - 1]! } : null;
    case "ArrowDown": {
      if (idx.length === 0) return null;
      const next = idx.find((i) => i > current);
      return { kind: "focus", index: next ?? idx[0]! };
    }
    case "ArrowUp": {
      if (idx.length === 0) return null;
      const prev = [...idx].reverse().find((i) => i < current);
      return { kind: "focus", index: prev ?? idx[idx.length - 1]! };
    }
    default:
      return null;
  }
}
